import { defineComponent as _defineComponent } from 'vue'
import { MediaPanel } from '@/widgets/MediaPanel'
import { Organization } from '@/modules/Organizations/types'


export default /*#__PURE__*/_defineComponent({
  __name: 'OrganizationMedia',
  props: {
    org: null
  },
  setup(__props: any) {



return { __sfc: true,MediaPanel }
}

})